/* eslint-disable react/no-unescaped-entities */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2018 Adobe Systems Incorporated
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
import React from 'react';
import { Page, MapTo, withComponentMappingContext } from '@adobe/cq-react-editable-components';
import { Body } from '@vds/typography';
import { ButtonIcon } from '@vds/button-icons';
import { Icon } from '@vds/icons';
import ReactDOMServer from 'react-dom/server';
import { withRouterV6 } from '../../utils/RouteHelper';
import { getAPPID, getSession, getUrlName, isEnableFwaRedesignFFlag, isMVA, setSession } from '../common/Helpers';
import { SignInPromptWrapper } from '../common/PageHeader.styles';
import PersistStore from './PersistStore';

require('./Page.css');

// This component is a variant of a Page component mapped to the "vcg/components/page" resource type
// For now, the rendering is the same as the RootPage; this is more for illustration purposes
class AppPage extends Page {
  get containerProps() {
    const attrs = super.containerProps;
    attrs.className = `${attrs.className || ''} page ${this.props.cssClassNames || ''}`;
    return attrs;
  }

  componentWillMount() {
    const isLoggedIn = getAPPID() === 'AAL';
    if (!isMVA() && !isLoggedIn && window?.vzFlags?.isSigninLink) {
      // we are removing signin
      const pageName = getUrlName(window.location.pathname);
      const isFwaRedesignEnabled = isEnableFwaRedesignFFlag();
      if (
        (isFwaRedesignEnabled ||
          (pageName !== 'streamlineordering' && pageName !== 'progressiveplan' && pageName !== 'popularplan')) &&
        !window.gnavdl?.options?.['hide-item'].includes('signIn')
      ) {
        window.gnavdl.options['hide-item'].push('signIn');
        window?.refreshGnav('');
      }
      try {
        if (
          !isFwaRedesignEnabled &&
          (pageName === 'progressiveplan' || pageName === 'streamlineordering') &&
          window?.gnavdl?.options &&
          window.gnavdl.options['hide-item']
        ) {
          window.gnavdl.options['hide-item'] = window.gnavdl.options['hide-item'].filter((item) => item !== 'signIn');
          window?.refreshGnav('');
          if (window.vzFlags.isSigninPrompt && getSession('signInPromptClosed') !== 'TRUE') {
            setTimeout(() => {
              const html = ReactDOMServer.renderToStaticMarkup(
                <SignInPromptWrapper>
                  <div className="fwa-signin-overlay" id="fwa_signin_prompt_overlay">
                    <div className="fwa-signin-text">
                      <div>
                        <Body size="large" bold primitive="span">
                          Sign in{' '}
                        </Body>
                        <Body size="large" primitive="span">
                          to your mobile account to find out if you're eligible for home internet discounts.
                        </Body>
                      </div>
                      <ButtonIcon
                        data-track='{"type": "link","name": "sign in prompt close","data":{"page":{"detail":"sign in" }}}'
                        id="prompt_close_button"
                        ariaLabel="prompt_close_button"
                        size="small"
                        renderIcon={() => <Icon name="close" size="medium" color="#000000" />}
                      />
                    </div>
                  </div>
                </SignInPromptWrapper>,
              );
              const signInButtons = document.querySelectorAll('#gnav20-sign-id, #gnav20-sign-id-mobile');
              for (let i = 0; i < signInButtons.length; i++) {
                const parentElementSelector = signInButtons[i].parentElement.querySelector('.gnav20-dropdown-menu');
                const hrefValue = signInButtons[i].parentElement.querySelector('.gnav20-dropdown-list-item').getAttribute('href');
                const hrefValueModified = hrefValue ? hrefValue.split('?')[0] : '';
                if (parentElementSelector) {
                  parentElementSelector.remove();
                }
                signInButtons[i].parentElement.style.position = 'relative';
                signInButtons[i].parentElement.parentElement.style.display = 'block';
                signInButtons[i].addEventListener('click', () => {
                  window.location.href = `${hrefValueModified}?goto=${window.location.origin}/sales/home/expresscart.html?expresscart=true&signinfromplans=true`;
                });
                signInButtons[i].setAttribute('data-track', '{"type":"link","name":"sign in|header"}');
                signInButtons[i].setAttribute('aria-label', 'sign in|header');
                signInButtons[i].insertAdjacentHTML('afterend', html);
              }
              const closeButtons = document.querySelectorAll('#prompt_close_button');
              for (let i = 0; i < closeButtons.length; i++) {
                closeButtons[i].addEventListener('click', () => {
                  setSession('signInPromptClosed', 'TRUE');
                  closeButtons[i].parentElement.parentElement.parentElement.style.display = 'none';
                });
              }
            }, 500);
          }
        }
      } catch (error) {
        console.log('error on gnavdl', error);
      }
    }
  }

  render() {
    return (
      <div>
        {!window?.vzFlags?.disableLocalStoargeUpdate && <PersistStore />}
        {this.childComponents}
      </div>
    );
  }
}

export default MapTo('vcg/components/soe-home/page/react-page')(withComponentMappingContext(withRouterV6(AppPage)));
